module.exports = __webpack_public_path__ + "7fc6339ec45b9a337c212ee6c043429e.woff2";